import CoinBundleItemsTable from "./CoinBundleItemsTable";
import ContractItemsTable from "./ContractItemsTable";
import PassItemsTable from "./PassItemsTable";
import TicketItemsTable from "./TicketItemsTable";

export default function StoreTypeItemsTable(props) {
  switch (props.type) {
    case '0':
      return <CoinBundleItemsTable {...props} />;
    case '2':
      return <PassItemsTable {...props} />;
    case '3':
      return <ContractItemsTable {...props} />;
    case '4':
      return <TicketItemsTable {...props} />;
    default:
      return <div>Unknown type: {props.type}</div>;
  }
}

